module.exports = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "conversations-visitor-ui": "static-1.28901",
      "ably": "static-2.2",
      "data-fetching-client": "static-1.9611",
      "ably-hubspot-js": "static-2.4652",
      "atom": "static-1.5008",
      "conversations-async-data": "static-2.7603",
      "conversations-error-reporting": "static-1.8819",
      "conversations-internal-pub-sub": "static-1.15909",
      "conversations-internal-schema": "static-1.12749",
      "conversations-message-history": "static-1.12471",
      "conversations-test-sdk": "static-1.10439",
      "conversations-visitor-experience-components": "static-1.22264",
      "head-dlb": "static-1.4938",
      "hs-promise-utils": "static-1.5531",
      "hs-test-utils": "static-1.7950",
      "hubspot-dlb": "static-2.1832",
      "HubStyleTokens": "static-2.11397",
      "I18n": "static-7.1610",
      "immer": "static-1.33",
      "jasmine-immutable": "static-1.2955",
      "jasmine-runner": "static-1.6406",
      "quartz": "static-1.6930",
      "react-dlb": "static-1.77",
      "react-select-plus": "static-1.103",
      "react-transition-group": "static-2.63",
      "redux-thunk": "static-2.43",
      "sanitize": "static-1.4409",
      "StyleGuideUI": "static-3.485",
      "transmute": "static-2.85",
      "urlinator": "static-1.4468",
      "usage-tracker": "static-1.7273",
      "usage-tracker-core": "static-1.7123",
      "usage-tracker-public": "static-1.7084",
      "viral-links-lib": "static-1.6989",
      "visitor-ui-component-library": "static-1.6074",
      "webpack-env": "static-1.54",
      "autolinker": "static-3.11",
      "classnames": "static-2.10",
      "conversations-http": "static-1.4746",
      "conversations-prop-types": "static-1.7390",
      "conversations-visitor-message-history": "static-1.21001",
      "cssUtils": "static-1.778",
      "enviro": "static-4.428",
      "flux-actions": "static-1.329",
      "foundations-components": "static-1.7802",
      "hs-lodash": "static-4.45",
      "hub-http": "static-1.6158",
      "hubspot-url-utils": "static-1.4049",
      "immutable": "static-2.77",
      "metrics-js": "static-1.9542",
      "PatternValidationJS": "static-1.437",
      "PortalIdParser": "static-2.388",
      "raven": "static-3.5829",
      "react": "static-7.184",
      "react-aria": "static-1.64",
      "react-dom": "static-7.85",
      "react-redux": "static-7.70",
      "react-rhumb": "static-1.16597",
      "react-utils": "static-2.5295",
      "redux": "static-4.16",
      "redux-toolkit": "static-1.7",
      "reselect": "static-2.16",
      "sanitize-text": "static-1.8081",
      "signup-constants": "static-1.18729",
      "styled-components": "static-2.88",
      "usage-tracker-multi": "static-1.5687",
      "visitor-ui-component-library-icons": "static-1.5885",
      "hs-promise-rejection-tracking": "static-1.5489",
      "raven-hubspot": "static-1.6136",
      "hoist-non-react-statics": "static-3.9",
      "bend-plugin-trellis-migration": "static-1.3355",
      "moment": "static-3.26",
      "apollo-stack-hubspot": "static-3.84",
      "fast-json-stable-stringify": "static-1.4",
      "graphql": "static-1.80",
      "quartz-config": "static-1.708",
      "quartz-core": "static-1.6149",
      "react-immutable-proptypes": "static-2.8",
      "foundations-assets": "static-1.4789",
      "foundations-theming": "static-1.4352",
      "UIComponents": "static-3.8344",
      "customer-data-email": "static-1.17916",
      "cv-backend-services": "static-1.1551",
      "immutable-less": "static-1.4588",
      "conversations-skeleton-state": "static-1.7187",
      "crm-events-viz-core": "static-1.32962",
      "customer-data-objects": "static-1.7598",
      "icons": "static-2.643",
      "react-input-autosize": "static-2.17",
      "rpc-client-utils": "static-1.4582",
      "ui-images": "static-2.1138",
      "HeadJS": "static-2.740",
      "framer-motion": "static-1.70",
      "hs-test-utils-bend-plugin": "static-1.3061",
      "msw": "static-1.39",
      "testing-library": "static-1.150",
      "i18n-data": "static-1.219",
      "moment-timezone": "static-5.81",
      "jasmine": "static-4.4261",
      "signup-ui-url-generator": "static-2.7973",
      "HubStyle": "static-2.11705",
      "quartz-i18n": "static-1.605",
      "sassPrefix": "static-1.154",
      "bend-plugin-foundations-components": "static-1.4071",
      "floating-ui": "static-1.54",
      "foundations-theming-specialty": "static-1.2068",
      "hs-story-utils": "static-1.9366",
      "react-virtualized": "static-2.97",
      "tanstack-table": "static-1.53",
      "trellis-assets": "static-1.1622",
      "ui-fonts": "static-1.659",
      "hs-locale-management": "static-1.35",
      "csstype": "static-1.50",
      "quartz-head": "static-1.595",
      "quick-fetch": "static-1.3868",
      "history": "static-4.47",
      "quartz-routing": "static-1.360",
      "usage-tracker-anonymous": "static-1.5690",
      "bender-build-tools": "static-1.3093",
      "dispatcher": "static-1.135",
      "general-store": "static-6.20",
      "hub-http-janus": "static-1.826",
      "hubspotter-http": "static-1.4603",
      "mobile-manifest-mixins": "static-1.514",
      "module-federation": "static-1.21",
      "quartz-auth": "static-1.605",
      "quartz-test": "static-1.605",
      "quartz-tracking": "static-1.309",
      "usage-tracker-container": "static-1.7263",
      "bend-plugin-foundations-theming": "static-1.2835",
      "foundations-theming-base": "static-1.3337",
      "stylex": "static-1.31",
      "apollo-dlb": "static-3.86",
      "apollo-link-hub-http": "static-2.4587",
      "customer-data-ui-utilities": "static-1.9763",
      "FileManagerCore": "static-1.38920",
      "FileManagerLib": "static-1.39061",
      "hubspot-apollo-client": "static-1.4815",
      "react-immutable-render-mixin": "static-1.9",
      "salesImages": "static-1.523",
      "timezone-utils": "static-2.5180",
      "ui-gdpr-components": "static-1.10284",
      "ts-schema": "static-1.4029",
      "ai-components-ui-library": "static-1.8770",
      "avatar-components": "static-1.2432",
      "content-assistance-lib": "static-1.7650",
      "crm-component-utils": "static-1.38893",
      "crm-display-components": "static-1.24643",
      "crm-fe-perf": "static-1.22842",
      "crm-links": "static-1.6216",
      "crm-message-bus": "static-1.42796",
      "crm-search-service-types": "static-1.1089",
      "crm-source-interpretation-lib": "static-1.5273",
      "customer-data-communicator": "static-1.45324",
      "customer-data-filters-ui": "static-1.39514",
      "customer-data-objects-ui-components": "static-1.12959",
      "customer-data-properties": "static-1.51307",
      "customer-data-rte": "static-1.32821",
      "draft-plugins": "static-2.21555",
      "file-manager-components": "static-1.23421",
      "framework-data-schema-resolvers": "static-1.6813",
      "frontend-preferences-client": "static-1.7863",
      "hubspot-prosemirror": "static-1.18037",
      "object-comments-thread-lib": "static-1.10477",
      "prosemirror-user-and-team-at-mentions": "static-1.448",
      "reference-resolvers-lite": "static-1.8029",
      "ui-addon-upgrades": "static-9.17893",
      "universal-associations-select": "static-1.10956",
      "universal-record-utils-lib": "static-1.673",
      "wootric-nps": "static-1.6924",
      "inbound-db-properties-service-client": "static-1.3793",
      "property-translator": "static-1.5339",
      "chirp-fetch": "static-1.1820",
      "react-router-dom": "static-5.26",
      "hub-http-shared-msw-handlers": "static-1.9810",
      "hubspotter-http-shared-msw-handlers": "static-1.9808",
      "usage-tracker-session-replay": "static-1.4959",
      "react-dnd-compat": "static-1.4556",
      "audio-components": "static-1.5814",
      "cropperjs": "static-1.10",
      "feedback-loader": "static-1.29177",
      "FileManagerImages": "static-1.36572",
      "foundations-components-legacy": "static-1.827",
      "immerable": "static-1.4090",
      "ui-universal-auth": "static-1.8894",
      "video-components": "static-1.13051",
      "video-data-lib": "static-1.34706",
      "video-embed": "static-1.35540",
      "hubspot-apollo-cache": "static-1.274",
      "chatspot-core": "static-1.20970",
      "ContentUtils": "static-1.68158",
      "copilot-toolkit": "static-1.10944",
      "superstore": "static-1.4705",
      "ui-addon-video-player": "static-1.8634",
      "ui-coaching-tips": "static-1.28352",
      "card-properties-lib": "static-1.43965",
      "commerce-subscription-lib": "static-1.36902",
      "crm-actions": "static-1.6254",
      "crm-cards-sdk": "static-1.43376",
      "customer-data-properties-shared-msw-handlers": "static-1.9137",
      "customer-data-property-utils": "static-1.8019",
      "customer-data-tracking": "static-1.6822",
      "hs-resources": "static-1.79",
      "inbound-db-meta-service-client": "static-1.3542",
      "pulse": "static-1.489",
      "framework-data-table": "static-2.11763",
      "location-customization-utils-lib": "static-1.9035",
      "calling-error-reporting": "static-1.31245",
      "calling-internal-common": "static-1.31239",
      "calling-usage-tracker": "static-1.6478",
      "crm_data": "static-4.91736",
      "customer-data-content": "static-1.27153",
      "draft-content-plugins": "static-1.28088",
      "draft-convert": "static-2.71",
      "draft-extend": "static-3.73",
      "draft-js": "static-5.76",
      "draft-signature-plugin": "static-1.23892",
      "EmailSignatureEditor": "static-1.24228",
      "hubspot-prosemirror-plugins": "static-1.18029",
      "integration-settings-components": "static-1.15268",
      "integrations-lib": "static-1.15893",
      "integrations-tracking-lib": "static-1.5534",
      "native-integrations-shared-strings": "static-1.7722",
      "nav-meta": "static-1.29437",
      "onboarding-scopes": "static-1.6401",
      "outreach-assistant-email-generation": "static-1.6080",
      "prosemirror-copilot": "static-1.11434",
      "prosemirror": "static-1.13",
      "quotes-client-types": "static-1.37830",
      "react-colorpicker": "static-2.10147",
      "reference-resolvers": "static-1.8107",
      "rich-text-lib": "static-1.19716",
      "sales-email-signature-service-client": "static-1.3780",
      "sequences-lib": "static-1.7925",
      "ui-addon-i18n": "static-1.11087",
      "ui-addon-iframeable": "static-1.8989",
      "ui-business-units-lib": "static-1.8981",
      "ui-shepherd-react": "static-3.10085",
      "user-context": "static-1.5037",
      "whatsapp-sending-lib": "static-1.5432",
      "customer-data-filters-ui-msw-helpers": "static-1.21949",
      "customer-data-reference-ui-components": "static-1.13093",
      "FormUrlGenerator": "static-2.4656",
      "framework-builder-read-service-client": "static-1.3961",
      "framework-data-schema-quick-fetch": "static-1.6718",
      "multi-account-reference-resolvers": "static-1.913",
      "onboarding-tours": "static-1.16473",
      "reporting-datasets-permissions-lib": "static-1.13471",
      "SharedI18nStrings": "static-1.182",
      "ui-addon-teams": "static-1.21463",
      "calling-global-api": "static-1.64261",
      "calling-lifecycle-internal": "static-1.65643",
      "calling-lifecycle-messages": "static-1.57937",
      "commerce-products-lib": "static-1.9275",
      "conditional-properties-service-client": "static-1.3748",
      "external-options-client-types": "static-1.4110",
      "google-libphonenumber": "static-1.36",
      "inbounddb-objects-service-types": "static-1.4175",
      "meetings-icalendar-utils-lib": "static-1.567",
      "multi-currency-client-types": "static-1.3643",
      "object-builder-ui-client": "static-1.48507",
      "pipeline-validation-client-types": "static-1.3917",
      "property-value-citations": "static-1.1921",
      "smart-property-lib": "static-1.6603",
      "tiered-pricing": "static-1.1069",
      "ui-addon-form-validation": "static-1.10927",
      "video-components-external": "static-1.11048",
      "batch-promise": "static-1.1489",
      "crm-pipelines-api-client-types": "static-1.4094",
      "persist-promise": "static-1.3646",
      "emoji-mart": "static-3.4",
      "growth-payments-core": "static-1.25162",
      "knowledge-content-types": "static-1.8479",
      "payment-link-components": "static-1.23338",
      "ui-addon-emoji-picker": "static-1.9824",
      "call-summary": "static-1.38951",
      "reference-resolvers-lite-shared-msw-handlers": "static-1.9956",
      "laboratory-lib": "static-3.7095",
      "merchandise-lib": "static-1.262",
      "purchase-motions-components": "static-1.5765",
      "crm-object-search-query-utilities": "static-1.9423",
      "amplitude-session-replay-browser": "static-1.58",
      "react-dnd": "static-5.6",
      "react-dnd-html5-backend": "static-5.6",
      "unified-auth-core-lib": "static-1.689",
      "content-icons-ui": "static-1.2211",
      "social-insights-client-types": "static-1.21881",
      "outpost": "static-1.4126",
      "markdown-it": "static-1.6",
      "cms-field-types": "static-1.4747",
      "underscore": "static-1.8",
      "magpie-lib": "static-1.5519",
      "magpie-types": "static-1.4979",
      "simple-logging-lib": "static-1.2987",
      "growth-onboarding-feedback-components": "static-1.6520",
      "customer-data-sidebar": "static-2.45813",
      "enrichment-properties-lib": "static-1.15721",
      "commerce-billing-lib": "static-1.18873",
      "commerce-shared-components-lib": "static-1.18337",
      "commerce-tools-ui-lib": "static-1.10198",
      "directed-graph": "static-1.874",
      "event-emitter": "static-1.885",
      "fast-json-patch": "static-1.61",
      "customer-data-associations": "static-1.7263",
      "deal-intel-decorators": "static-1.1770",
      "reporting-data": "static-1.67210",
      "tanstack-virtual": "static-1.28",
      "ui-addon-draggable": "static-3.4706",
      "crm-record-cards-service-types": "static-1.3562",
      "self-service-api": "static-1.10182",
      "crm_universal": "static-1.21890",
      "SalesContentIndexUI": "static-3.9147",
      "content-embed-lib": "static-1.7277",
      "data-model-builder-lib": "static-1.12111",
      "remote-ui": "static-1.63",
      "ui-components-test-utils": "static-1.5535",
      "ui-extensions-remote-renderer": "static-1.16825",
      "universal-page-editor-lib": "static-1.2946",
      "integrations-error-boundary-lib": "static-1.13308",
      "redux-observable": "static-1.11",
      "ReduxMessenger": "static-2.10310",
      "rxjs": "static-5.10",
      "unified-auth": "static-1.408",
      "messaging-types-lib": "static-1.45793",
      "ai-addon-copilot-preview": "static-1.7982",
      "copilot-plugins": "static-1.10917",
      "data-token-picker": "static-1.16287",
      "sequences-client-types-lib": "static-1.7782",
      "foundations-components-test-utils": "static-1.5285",
      "navigation-messaging": "static-1.7127",
      "getting-started-shared-tasks": "static-1.18304",
      "getting-started-shared-tasks-store": "static-1.17422",
      "onboarding-tours-utils": "static-1.539",
      "messaging-usage-based-billing-components-lib": "static-1.918",
      "whatsapp-management-lib": "static-1.8591",
      "growth-data-modal": "static-1.5322",
      "growth-onboarding-confetti": "static-1.3006",
      "growth-onboarding-next-action-utils": "static-1.1712",
      "navigation-components": "static-1.17800",
      "onboarding-tours-client": "static-1.4687",
      "ui-shepherd-tracker": "static-1.7466",
      "shared-worker-versioning": "static-1.10974",
      "voice-sms-access-library": "static-1.715",
      "commerce-permissions": "static-1.703",
      "products-iframe-lib": "static-1.7735",
      "products-ui-components-shared-msw-handlers": "static-1.10192",
      "data-agent-kit": "static-1.88",
      "framework-data-schema-resolvers-shared-msw-handlers": "static-1.9893",
      "fsm": "static-1.3671",
      "policy-lib": "static-1.6712",
      "react-tinymce": "static-1.55049",
      "tinymce": "static-5.11",
      "tinymce-config": "static-2.54175",
      "tinymce-plugins": "static-1.57289",
      "tinymce-themes": "static-1.56145",
      "content-media-composition-data-lib": "static-1.12027",
      "content-media-compositions": "static-2.16034",
      "idb-keyval": "static-1.42",
      "media-bridge-lib": "static-1.18810",
      "ui-addon-opt": "static-4.8317",
      "commerce-tours-lib": "static-1.5972",
      "growth-onboarding-reliability": "static-1.5020",
      "sales-checkout-service-client": "static-1.3577",
      "calling-cross-tab-library": "static-1.19214",
      "calling-lifecycle-usage-tracker": "static-1.8522",
      "purchase-motions-api": "static-1.5768",
      "trials-service-types": "static-1.3839",
      "reactive-lib": "static-1.659",
      "card-payment-highlight-lib": "static-1.36969",
      "card-subscription-highlight-lib": "static-1.39325",
      "commerce-contract-lib": "static-1.11751",
      "invoices-highlight-card-lib": "static-1.54485",
      "orders-highlight-card-lib": "static-1.21267",
      "products-highlight-card-lib": "static-1.17559",
      "quotes-highlight-card-lib": "static-1.71740",
      "usage-based-billing-components-lib": "static-1.8549",
      "utility-belt": "static-1.2476",
      "payments-enrollment-embed-lib": "static-1.22445",
      "stripe-embedded-components": "static-1.7385",
      "growth-onboarding-empty-states": "static-1.5596",
      "InboxConnectUtils": "static-4.14618",
      "payments-post-enroll-local-storage-lib": "static-1.5048",
      "qrcode-generator": "static-1.67",
      "deal-intel-utils": "static-1.1774",
      "storybook-react": "static-1.31",
      "reporting-client-types": "static-1.2455",
      "react-flip-move": "static-1.68",
      "FireAlarmUi": "static-1.4465",
      "sales-templates-service-types-lib": "static-1.4119",
      "ui-asset-management-lib": "static-1.10936",
      "association-settings-lib": "static-1.10090",
      "collaboration-sidebar": "static-1.57586",
      "conditional-property-settings-modal": "static-1.12305",
      "data-model-commons-lib": "static-1.12381",
      "final-form": "static-1.68",
      "html-to-image": "static-1.52",
      "nudge-client-utils": "static-1.2419",
      "object-definition-builder-lib": "static-1.7022",
      "property-management-iframe": "static-1.12934",
      "property-usages-lib": "static-1.5351",
      "reactflow": "static-1.62",
      "simple-data-table": "static-1.2581",
      "used-in-list-lib": "static-1.6877",
      "visual-association": "static-1.5804",
      "highcharts": "static-8.102",
      "reporting-visualizations": "static-1.59286",
      "ui-extensibility-client-types": "static-1.3873",
      "google-sheets-integration-lib": "static-1.36",
      "microsoft-drive-integration-lib": "static-1.136",
      "automation-platform-service-types": "static-1.2562",
      "ContentData": "static-1.68233",
      "email-portal-health-service-types": "static-1.914",
      "marketing-email-service-types": "static-1.1871",
      "ai-rendering-library": "static-1.9872",
      "ai-settings-ui-library": "static-1.7776",
      "ui-brand-identity-lib": "static-1.14948",
      "messaging-shared-utils-lib": "static-1.367",
      "messaging-user-info-utils-lib": "static-1.537",
      "content-whatsapp-service-types": "static-1.341",
      "marketing-platform-lib": "static-1.6788",
      "short-messages-app-service-client": "static-1.3918",
      "ui-tool-access": "static-1.10085",
      "onboarding-data-sync-lib": "static-1.1846",
      "growth-onboarding-next-action-components": "static-1.1740",
      "user-context-client": "static-1.4548",
      "nest": "static-1.160",
      "calling-orchestration-schema": "static-1.35492",
      "sales-views-client-types": "static-1.4200",
      "trellis-story-utils": "static-1.4454",
      "hub-http-contrib": "static-1.2978",
      "interframe": "static-3.4699",
      "tinymce-data": "static-1.40260",
      "ui-addon-sales-email": "static-1.5148",
      "codemirror": "static-5.93",
      "layout-dnd-components": "static-1.12316",
      "layout-dnd-utils": "static-1.11291",
      "react-codemirror": "static-1.10560",
      "NamespacedHubStyle": "static-2.9015",
      "js-cookie": "static-1.18",
      "products-ui-components": "static-1.39794",
      "quotes-ui-lib": "static-1.80461",
      "zustand": "static-1.72",
      "accounting-integrations-ui-components": "static-1.6955",
      "invoices-ui-lib": "static-1.54501",
      "commerce-products-api": "static-1.2193",
      "invoices-iframe-lib": "static-1.56559",
      "quotes-modal-lib": "static-1.102418",
      "platform-infra-nav-components": "static-1.7619",
      "reporting-ui-components": "static-2.64481",
      "subscription-experience-data-types": "static-1.14821",
      "marketplace-ui-apps-core": "static-1.17986",
      "stripe-connect-js": "static-1.67",
      "ui-addon-react-router-dom": "static-1.9481",
      "nested-table": "static-1.163",
      "chatspot-widget-iframe": "static-1.20961",
      "collaboration-sidebar-common": "static-1.2383",
      "crm-properties-common-lib": "static-1.5813",
      "ui-addon-draggable-compat": "static-2.4191",
      "nudge-custom-function-registry": "static-1.2176",
      "nudge-renderer-utils": "static-1.2495",
      "whisper-core-api": "static-1.6405",
      "property-management-common": "static-1.5222",
      "d3": "static-1.7",
      "advanced-menus-core": "static-1.15025",
      "advanced-menus-lib": "static-1.11980",
      "ExportDialog": "static-6.10329",
      "ui-memberships-settings-lib": "static-1.33855",
      "embedded-academy-lib": "static-1.14111",
      "highlight.js": "static-1.77",
      "reporting-action-components": "static-1.41115",
      "reporting-snowflake": "static-1.55828",
      "diff-match-patch": "static-1.7",
      "layout-data-lib": "static-1.9616",
      "browser-eslint": "static-2.57",
      "commerce-tax-lib": "static-1.457",
      "property-description-translator": "static-1.3784",
      "commerce-analytics-service-client": "static-1.3565",
      "totals-ui-components": "static-1.23395",
      "reporting-plugins": "static-1.10186",
      "reporting-reports": "static-1.66888",
      "edison-service-client-types": "static-1.324",
      "developer-experience-shared-components": "static-1.10445",
      "marketplace-ui-client-types": "static-1.16860",
      "marketplace-ui-common": "static-1.19453",
      "ui-addon-integrations-directory-panel": "static-2.7931",
      "react-window": "static-1.13",
      "ts-utils-lib": "static-1.110",
      "seamless-immutable": "static-7.6",
      "simple-menus-core": "static-1.15024",
      "simple-menus-lib": "static-1.16541",
      "academy-common-lib": "static-1.13571",
      "dashboard-lib": "static-1.81254",
      "share-with-third-party-component-lib": "static-1.8634",
      "commerce-totals-service-types": "static-1.3770",
      "campaign-roi-lib": "static-1.8827",
      "apps-service-types": "static-1.3815",
      "oauth-service-types": "static-1.4187",
      "academy-service-client": "static-1.3618",
      "croppie": "static-2.10",
      "redux-actions": "static-3.7"
    },
    "depPathPrefixes": {
      "conversations-visitor-ui": "/conversations-visitor-ui/static-1.28901",
      "ably": "/ably/static-2.2",
      "data-fetching-client": "/data-fetching-client/static-1.9611",
      "ably-hubspot-js": "/ably-hubspot-js/static-2.4652",
      "atom": "/atom/static-1.5008",
      "conversations-async-data": "/conversations-async-data/static-2.7603",
      "conversations-error-reporting": "/conversations-error-reporting/static-1.8819",
      "conversations-internal-pub-sub": "/conversations-internal-pub-sub/static-1.15909",
      "conversations-internal-schema": "/conversations-internal-schema/static-1.12749",
      "conversations-message-history": "/conversations-message-history/static-1.12471",
      "conversations-test-sdk": "/conversations-test-sdk/static-1.10439",
      "conversations-visitor-experience-components": "/conversations-visitor-experience-components/static-1.22264",
      "head-dlb": "/head-dlb/static-1.4938",
      "hs-promise-utils": "/hs-promise-utils/static-1.5531",
      "hs-test-utils": "/hs-test-utils/static-1.7950",
      "hubspot-dlb": "/hubspot-dlb/static-2.1832",
      "HubStyleTokens": "/HubStyleTokens/static-2.11397",
      "I18n": "/I18n/static-7.1610",
      "immer": "/immer/static-1.33",
      "jasmine-immutable": "/jasmine-immutable/static-1.2955",
      "jasmine-runner": "/jasmine-runner/static-1.6406",
      "quartz": "/quartz/static-1.6930",
      "react-dlb": "/react-dlb/static-1.77",
      "react-select-plus": "/react-select-plus/static-1.103",
      "react-transition-group": "/react-transition-group/static-2.63",
      "redux-thunk": "/redux-thunk/static-2.43",
      "sanitize": "/sanitize/static-1.4409",
      "StyleGuideUI": "/StyleGuideUI/static-3.485",
      "transmute": "/transmute/static-2.85",
      "urlinator": "/urlinator/static-1.4468",
      "usage-tracker": "/usage-tracker/static-1.7273",
      "usage-tracker-core": "/usage-tracker-core/static-1.7123",
      "usage-tracker-public": "/usage-tracker-public/static-1.7084",
      "viral-links-lib": "/viral-links-lib/static-1.6989",
      "visitor-ui-component-library": "/visitor-ui-component-library/static-1.6074",
      "webpack-env": "/webpack-env/static-1.54",
      "autolinker": "/autolinker/static-3.11",
      "classnames": "/classnames/static-2.10",
      "conversations-http": "/conversations-http/static-1.4746",
      "conversations-prop-types": "/conversations-prop-types/static-1.7390",
      "conversations-visitor-message-history": "/conversations-visitor-message-history/static-1.21001",
      "cssUtils": "/cssUtils/static-1.778",
      "enviro": "/enviro/static-4.428",
      "flux-actions": "/flux-actions/static-1.329",
      "foundations-components": "/foundations-components/static-1.7802",
      "hs-lodash": "/hs-lodash/static-4.45",
      "hub-http": "/hub-http/static-1.6158",
      "hubspot-url-utils": "/hubspot-url-utils/static-1.4049",
      "immutable": "/immutable/static-2.77",
      "metrics-js": "/metrics-js/static-1.9542",
      "PatternValidationJS": "/PatternValidationJS/static-1.437",
      "PortalIdParser": "/PortalIdParser/static-2.388",
      "raven": "/raven/static-3.5829",
      "react": "/react/static-7.184",
      "react-aria": "/react-aria/static-1.64",
      "react-dom": "/react-dom/static-7.85",
      "react-redux": "/react-redux/static-7.70",
      "react-rhumb": "/react-rhumb/static-1.16597",
      "react-utils": "/react-utils/static-2.5295",
      "redux": "/redux/static-4.16",
      "redux-toolkit": "/redux-toolkit/static-1.7",
      "reselect": "/reselect/static-2.16",
      "sanitize-text": "/sanitize-text/static-1.8081",
      "signup-constants": "/signup-constants/static-1.18729",
      "styled-components": "/styled-components/static-2.88",
      "usage-tracker-multi": "/usage-tracker-multi/static-1.5687",
      "visitor-ui-component-library-icons": "/visitor-ui-component-library-icons/static-1.5885",
      "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5489",
      "raven-hubspot": "/raven-hubspot/static-1.6136",
      "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
      "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3355",
      "moment": "/moment/static-3.26",
      "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.84",
      "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
      "graphql": "/graphql/static-1.80",
      "quartz-config": "/quartz-config/static-1.708",
      "quartz-core": "/quartz-core/static-1.6149",
      "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
      "foundations-assets": "/foundations-assets/static-1.4789",
      "foundations-theming": "/foundations-theming/static-1.4352",
      "UIComponents": "/UIComponents/static-3.8344",
      "customer-data-email": "/customer-data-email/static-1.17916",
      "cv-backend-services": "/cv-backend-services/static-1.1551",
      "immutable-less": "/immutable-less/static-1.4588",
      "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7187",
      "crm-events-viz-core": "/crm-events-viz-core/static-1.32962",
      "customer-data-objects": "/customer-data-objects/static-1.7598",
      "icons": "/icons/static-2.643",
      "react-input-autosize": "/react-input-autosize/static-2.17",
      "rpc-client-utils": "/rpc-client-utils/static-1.4582",
      "ui-images": "/ui-images/static-2.1138",
      "HeadJS": "/HeadJS/static-2.740",
      "framer-motion": "/framer-motion/static-1.70",
      "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3061",
      "msw": "/msw/static-1.39",
      "testing-library": "/testing-library/static-1.150",
      "i18n-data": "/i18n-data/static-1.219",
      "moment-timezone": "/moment-timezone/static-5.81",
      "jasmine": "/jasmine/static-4.4261",
      "signup-ui-url-generator": "/signup-ui-url-generator/static-2.7973",
      "HubStyle": "/HubStyle/static-2.11705",
      "quartz-i18n": "/quartz-i18n/static-1.605",
      "sassPrefix": "/sassPrefix/static-1.154",
      "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4071",
      "floating-ui": "/floating-ui/static-1.54",
      "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2068",
      "hs-story-utils": "/hs-story-utils/static-1.9366",
      "react-virtualized": "/react-virtualized/static-2.97",
      "tanstack-table": "/tanstack-table/static-1.53",
      "trellis-assets": "/trellis-assets/static-1.1622",
      "ui-fonts": "/ui-fonts/static-1.659",
      "hs-locale-management": "/hs-locale-management/static-1.35",
      "csstype": "/csstype/static-1.50",
      "quartz-head": "/quartz-head/static-1.595",
      "quick-fetch": "/quick-fetch/static-1.3868",
      "history": "/history/static-4.47",
      "quartz-routing": "/quartz-routing/static-1.360",
      "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5690",
      "bender-build-tools": "/bender-build-tools/static-1.3093",
      "dispatcher": "/dispatcher/static-1.135",
      "general-store": "/general-store/static-6.20",
      "hub-http-janus": "/hub-http-janus/static-1.826",
      "hubspotter-http": "/hubspotter-http/static-1.4603",
      "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.514",
      "module-federation": "/module-federation/static-1.21",
      "quartz-auth": "/quartz-auth/static-1.605",
      "quartz-test": "/quartz-test/static-1.605",
      "quartz-tracking": "/quartz-tracking/static-1.309",
      "usage-tracker-container": "/usage-tracker-container/static-1.7263",
      "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2835",
      "foundations-theming-base": "/foundations-theming-base/static-1.3337",
      "stylex": "/stylex/static-1.31",
      "apollo-dlb": "/apollo-dlb/static-3.86",
      "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4587",
      "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9763",
      "FileManagerCore": "/FileManagerCore/static-1.38920",
      "FileManagerLib": "/FileManagerLib/static-1.39061",
      "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4815",
      "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
      "salesImages": "/salesImages/static-1.523",
      "timezone-utils": "/timezone-utils/static-2.5180",
      "ui-gdpr-components": "/ui-gdpr-components/static-1.10284",
      "ts-schema": "/ts-schema/static-1.4029",
      "ai-components-ui-library": "/ai-components-ui-library/static-1.8770",
      "avatar-components": "/avatar-components/static-1.2432",
      "content-assistance-lib": "/content-assistance-lib/static-1.7650",
      "crm-component-utils": "/crm-component-utils/static-1.38893",
      "crm-display-components": "/crm-display-components/static-1.24643",
      "crm-fe-perf": "/crm-fe-perf/static-1.22842",
      "crm-links": "/crm-links/static-1.6216",
      "crm-message-bus": "/crm-message-bus/static-1.42796",
      "crm-search-service-types": "/crm-search-service-types/static-1.1089",
      "crm-source-interpretation-lib": "/crm-source-interpretation-lib/static-1.5273",
      "customer-data-communicator": "/customer-data-communicator/static-1.45324",
      "customer-data-filters-ui": "/customer-data-filters-ui/static-1.39514",
      "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.12959",
      "customer-data-properties": "/customer-data-properties/static-1.51307",
      "customer-data-rte": "/customer-data-rte/static-1.32821",
      "draft-plugins": "/draft-plugins/static-2.21555",
      "file-manager-components": "/file-manager-components/static-1.23421",
      "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6813",
      "frontend-preferences-client": "/frontend-preferences-client/static-1.7863",
      "hubspot-prosemirror": "/hubspot-prosemirror/static-1.18037",
      "object-comments-thread-lib": "/object-comments-thread-lib/static-1.10477",
      "prosemirror-user-and-team-at-mentions": "/prosemirror-user-and-team-at-mentions/static-1.448",
      "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8029",
      "ui-addon-upgrades": "/ui-addon-upgrades/static-9.17893",
      "universal-associations-select": "/universal-associations-select/static-1.10956",
      "universal-record-utils-lib": "/universal-record-utils-lib/static-1.673",
      "wootric-nps": "/wootric-nps/static-1.6924",
      "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3793",
      "property-translator": "/property-translator/static-1.5339",
      "chirp-fetch": "/chirp-fetch/static-1.1820",
      "react-router-dom": "/react-router-dom/static-5.26",
      "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9810",
      "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9808",
      "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.4959",
      "react-dnd-compat": "/react-dnd-compat/static-1.4556",
      "audio-components": "/audio-components/static-1.5814",
      "cropperjs": "/cropperjs/static-1.10",
      "feedback-loader": "/feedback-loader/static-1.29177",
      "FileManagerImages": "/FileManagerImages/static-1.36572",
      "foundations-components-legacy": "/foundations-components-legacy/static-1.827",
      "immerable": "/immerable/static-1.4090",
      "ui-universal-auth": "/ui-universal-auth/static-1.8894",
      "video-components": "/video-components/static-1.13051",
      "video-data-lib": "/video-data-lib/static-1.34706",
      "video-embed": "/video-embed/static-1.35540",
      "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.274",
      "chatspot-core": "/chatspot-core/static-1.20970",
      "ContentUtils": "/ContentUtils/static-1.68158",
      "copilot-toolkit": "/copilot-toolkit/static-1.10944",
      "superstore": "/superstore/static-1.4705",
      "ui-addon-video-player": "/ui-addon-video-player/static-1.8634",
      "ui-coaching-tips": "/ui-coaching-tips/static-1.28352",
      "card-properties-lib": "/card-properties-lib/static-1.43965",
      "commerce-subscription-lib": "/commerce-subscription-lib/static-1.36902",
      "crm-actions": "/crm-actions/static-1.6254",
      "crm-cards-sdk": "/crm-cards-sdk/static-1.43376",
      "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9137",
      "customer-data-property-utils": "/customer-data-property-utils/static-1.8019",
      "customer-data-tracking": "/customer-data-tracking/static-1.6822",
      "hs-resources": "/hs-resources/static-1.79",
      "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3542",
      "pulse": "/pulse/static-1.489",
      "framework-data-table": "/framework-data-table/static-2.11763",
      "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9035",
      "calling-error-reporting": "/calling-error-reporting/static-1.31245",
      "calling-internal-common": "/calling-internal-common/static-1.31239",
      "calling-usage-tracker": "/calling-usage-tracker/static-1.6478",
      "crm_data": "/crm_data/static-4.91736",
      "customer-data-content": "/customer-data-content/static-1.27153",
      "draft-content-plugins": "/draft-content-plugins/static-1.28088",
      "draft-convert": "/draft-convert/static-2.71",
      "draft-extend": "/draft-extend/static-3.73",
      "draft-js": "/draft-js/static-5.76",
      "draft-signature-plugin": "/draft-signature-plugin/static-1.23892",
      "EmailSignatureEditor": "/EmailSignatureEditor/static-1.24228",
      "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.18029",
      "integration-settings-components": "/integration-settings-components/static-1.15268",
      "integrations-lib": "/integrations-lib/static-1.15893",
      "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5534",
      "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7722",
      "nav-meta": "/nav-meta/static-1.29437",
      "onboarding-scopes": "/onboarding-scopes/static-1.6401",
      "outreach-assistant-email-generation": "/outreach-assistant-email-generation/static-1.6080",
      "prosemirror-copilot": "/prosemirror-copilot/static-1.11434",
      "prosemirror": "/prosemirror/static-1.13",
      "quotes-client-types": "/quotes-client-types/static-1.37830",
      "react-colorpicker": "/react-colorpicker/static-2.10147",
      "reference-resolvers": "/reference-resolvers/static-1.8107",
      "rich-text-lib": "/rich-text-lib/static-1.19716",
      "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.3780",
      "sequences-lib": "/sequences-lib/static-1.7925",
      "ui-addon-i18n": "/ui-addon-i18n/static-1.11087",
      "ui-addon-iframeable": "/ui-addon-iframeable/static-1.8989",
      "ui-business-units-lib": "/ui-business-units-lib/static-1.8981",
      "ui-shepherd-react": "/ui-shepherd-react/static-3.10085",
      "user-context": "/user-context/static-1.5037",
      "whatsapp-sending-lib": "/whatsapp-sending-lib/static-1.5432",
      "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.21949",
      "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13093",
      "FormUrlGenerator": "/FormUrlGenerator/static-2.4656",
      "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3961",
      "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6718",
      "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.913",
      "onboarding-tours": "/onboarding-tours/static-1.16473",
      "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.13471",
      "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
      "ui-addon-teams": "/ui-addon-teams/static-1.21463",
      "calling-global-api": "/calling-global-api/static-1.64261",
      "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.65643",
      "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.57937",
      "commerce-products-lib": "/commerce-products-lib/static-1.9275",
      "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3748",
      "external-options-client-types": "/external-options-client-types/static-1.4110",
      "google-libphonenumber": "/google-libphonenumber/static-1.36",
      "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4175",
      "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.567",
      "multi-currency-client-types": "/multi-currency-client-types/static-1.3643",
      "object-builder-ui-client": "/object-builder-ui-client/static-1.48507",
      "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3917",
      "property-value-citations": "/property-value-citations/static-1.1921",
      "smart-property-lib": "/smart-property-lib/static-1.6603",
      "tiered-pricing": "/tiered-pricing/static-1.1069",
      "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10927",
      "video-components-external": "/video-components-external/static-1.11048",
      "batch-promise": "/batch-promise/static-1.1489",
      "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4094",
      "persist-promise": "/persist-promise/static-1.3646",
      "emoji-mart": "/emoji-mart/static-3.4",
      "growth-payments-core": "/growth-payments-core/static-1.25162",
      "knowledge-content-types": "/knowledge-content-types/static-1.8479",
      "payment-link-components": "/payment-link-components/static-1.23338",
      "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9824",
      "call-summary": "/call-summary/static-1.38951",
      "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.9956",
      "laboratory-lib": "/laboratory-lib/static-3.7095",
      "merchandise-lib": "/merchandise-lib/static-1.262",
      "purchase-motions-components": "/purchase-motions-components/static-1.5765",
      "crm-object-search-query-utilities": "/crm-object-search-query-utilities/static-1.9423",
      "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.58",
      "react-dnd": "/react-dnd/static-5.6",
      "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
      "unified-auth-core-lib": "/unified-auth-core-lib/static-1.689",
      "content-icons-ui": "/content-icons-ui/static-1.2211",
      "social-insights-client-types": "/social-insights-client-types/static-1.21881",
      "outpost": "/outpost/static-1.4126",
      "markdown-it": "/markdown-it/static-1.6",
      "cms-field-types": "/cms-field-types/static-1.4747",
      "underscore": "/underscore/static-1.8",
      "magpie-lib": "/magpie-lib/static-1.5519",
      "magpie-types": "/magpie-types/static-1.4979",
      "simple-logging-lib": "/simple-logging-lib/static-1.2987",
      "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6520",
      "customer-data-sidebar": "/customer-data-sidebar/static-2.45813",
      "enrichment-properties-lib": "/enrichment-properties-lib/static-1.15721",
      "commerce-billing-lib": "/commerce-billing-lib/static-1.18873",
      "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.18337",
      "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.10198",
      "directed-graph": "/directed-graph/static-1.874",
      "event-emitter": "/event-emitter/static-1.885",
      "fast-json-patch": "/fast-json-patch/static-1.61",
      "customer-data-associations": "/customer-data-associations/static-1.7263",
      "deal-intel-decorators": "/deal-intel-decorators/static-1.1770",
      "reporting-data": "/reporting-data/static-1.67210",
      "tanstack-virtual": "/tanstack-virtual/static-1.28",
      "ui-addon-draggable": "/ui-addon-draggable/static-3.4706",
      "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3562",
      "self-service-api": "/self-service-api/static-1.10182",
      "crm_universal": "/crm_universal/static-1.21890",
      "SalesContentIndexUI": "/SalesContentIndexUI/static-3.9147",
      "content-embed-lib": "/content-embed-lib/static-1.7277",
      "data-model-builder-lib": "/data-model-builder-lib/static-1.12111",
      "remote-ui": "/remote-ui/static-1.63",
      "ui-components-test-utils": "/ui-components-test-utils/static-1.5535",
      "ui-extensions-remote-renderer": "/ui-extensions-remote-renderer/static-1.16825",
      "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2946",
      "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13308",
      "redux-observable": "/redux-observable/static-1.11",
      "ReduxMessenger": "/ReduxMessenger/static-2.10310",
      "rxjs": "/rxjs/static-5.10",
      "unified-auth": "/unified-auth/static-1.408",
      "messaging-types-lib": "/messaging-types-lib/static-1.45793",
      "ai-addon-copilot-preview": "/ai-addon-copilot-preview/static-1.7982",
      "copilot-plugins": "/copilot-plugins/static-1.10917",
      "data-token-picker": "/data-token-picker/static-1.16287",
      "sequences-client-types-lib": "/sequences-client-types-lib/static-1.7782",
      "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5285",
      "navigation-messaging": "/navigation-messaging/static-1.7127",
      "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.18304",
      "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.17422",
      "onboarding-tours-utils": "/onboarding-tours-utils/static-1.539",
      "messaging-usage-based-billing-components-lib": "/messaging-usage-based-billing-components-lib/static-1.918",
      "whatsapp-management-lib": "/whatsapp-management-lib/static-1.8591",
      "growth-data-modal": "/growth-data-modal/static-1.5322",
      "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3006",
      "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1712",
      "navigation-components": "/navigation-components/static-1.17800",
      "onboarding-tours-client": "/onboarding-tours-client/static-1.4687",
      "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7466",
      "shared-worker-versioning": "/shared-worker-versioning/static-1.10974",
      "voice-sms-access-library": "/voice-sms-access-library/static-1.715",
      "commerce-permissions": "/commerce-permissions/static-1.703",
      "products-iframe-lib": "/products-iframe-lib/static-1.7735",
      "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10192",
      "data-agent-kit": "/data-agent-kit/static-1.88",
      "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.9893",
      "fsm": "/fsm/static-1.3671",
      "policy-lib": "/policy-lib/static-1.6712",
      "react-tinymce": "/react-tinymce/static-1.55049",
      "tinymce": "/tinymce/static-5.11",
      "tinymce-config": "/tinymce-config/static-2.54175",
      "tinymce-plugins": "/tinymce-plugins/static-1.57289",
      "tinymce-themes": "/tinymce-themes/static-1.56145",
      "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.12027",
      "content-media-compositions": "/content-media-compositions/static-2.16034",
      "idb-keyval": "/idb-keyval/static-1.42",
      "media-bridge-lib": "/media-bridge-lib/static-1.18810",
      "ui-addon-opt": "/ui-addon-opt/static-4.8317",
      "commerce-tours-lib": "/commerce-tours-lib/static-1.5972",
      "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5020",
      "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3577",
      "calling-cross-tab-library": "/calling-cross-tab-library/static-1.19214",
      "calling-lifecycle-usage-tracker": "/calling-lifecycle-usage-tracker/static-1.8522",
      "purchase-motions-api": "/purchase-motions-api/static-1.5768",
      "trials-service-types": "/trials-service-types/static-1.3839",
      "reactive-lib": "/reactive-lib/static-1.659",
      "card-payment-highlight-lib": "/card-payment-highlight-lib/static-1.36969",
      "card-subscription-highlight-lib": "/card-subscription-highlight-lib/static-1.39325",
      "commerce-contract-lib": "/commerce-contract-lib/static-1.11751",
      "invoices-highlight-card-lib": "/invoices-highlight-card-lib/static-1.54485",
      "orders-highlight-card-lib": "/orders-highlight-card-lib/static-1.21267",
      "products-highlight-card-lib": "/products-highlight-card-lib/static-1.17559",
      "quotes-highlight-card-lib": "/quotes-highlight-card-lib/static-1.71740",
      "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.8549",
      "utility-belt": "/utility-belt/static-1.2476",
      "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.22445",
      "stripe-embedded-components": "/stripe-embedded-components/static-1.7385",
      "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.5596",
      "InboxConnectUtils": "/InboxConnectUtils/static-4.14618",
      "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.5048",
      "qrcode-generator": "/qrcode-generator/static-1.67",
      "deal-intel-utils": "/deal-intel-utils/static-1.1774",
      "storybook-react": "/storybook-react/static-1.31",
      "reporting-client-types": "/reporting-client-types/static-1.2455",
      "react-flip-move": "/react-flip-move/static-1.68",
      "FireAlarmUi": "/FireAlarmUi/static-1.4465",
      "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.4119",
      "ui-asset-management-lib": "/ui-asset-management-lib/static-1.10936",
      "association-settings-lib": "/association-settings-lib/static-1.10090",
      "collaboration-sidebar": "/collaboration-sidebar/static-1.57586",
      "conditional-property-settings-modal": "/conditional-property-settings-modal/static-1.12305",
      "data-model-commons-lib": "/data-model-commons-lib/static-1.12381",
      "final-form": "/final-form/static-1.68",
      "html-to-image": "/html-to-image/static-1.52",
      "nudge-client-utils": "/nudge-client-utils/static-1.2419",
      "object-definition-builder-lib": "/object-definition-builder-lib/static-1.7022",
      "property-management-iframe": "/property-management-iframe/static-1.12934",
      "property-usages-lib": "/property-usages-lib/static-1.5351",
      "reactflow": "/reactflow/static-1.62",
      "simple-data-table": "/simple-data-table/static-1.2581",
      "used-in-list-lib": "/used-in-list-lib/static-1.6877",
      "visual-association": "/visual-association/static-1.5804",
      "highcharts": "/highcharts/static-8.102",
      "reporting-visualizations": "/reporting-visualizations/static-1.59286",
      "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.3873",
      "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.36",
      "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.136",
      "automation-platform-service-types": "/automation-platform-service-types/static-1.2562",
      "ContentData": "/ContentData/static-1.68233",
      "email-portal-health-service-types": "/email-portal-health-service-types/static-1.914",
      "marketing-email-service-types": "/marketing-email-service-types/static-1.1871",
      "ai-rendering-library": "/ai-rendering-library/static-1.9872",
      "ai-settings-ui-library": "/ai-settings-ui-library/static-1.7776",
      "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.14948",
      "messaging-shared-utils-lib": "/messaging-shared-utils-lib/static-1.367",
      "messaging-user-info-utils-lib": "/messaging-user-info-utils-lib/static-1.537",
      "content-whatsapp-service-types": "/content-whatsapp-service-types/static-1.341",
      "marketing-platform-lib": "/marketing-platform-lib/static-1.6788",
      "short-messages-app-service-client": "/short-messages-app-service-client/static-1.3918",
      "ui-tool-access": "/ui-tool-access/static-1.10085",
      "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.1846",
      "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.1740",
      "user-context-client": "/user-context-client/static-1.4548",
      "nest": "/nest/static-1.160",
      "calling-orchestration-schema": "/calling-orchestration-schema/static-1.35492",
      "sales-views-client-types": "/sales-views-client-types/static-1.4200",
      "trellis-story-utils": "/trellis-story-utils/static-1.4454",
      "hub-http-contrib": "/hub-http-contrib/static-1.2978",
      "interframe": "/interframe/static-3.4699",
      "tinymce-data": "/tinymce-data/static-1.40260",
      "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5148",
      "codemirror": "/codemirror/static-5.93",
      "layout-dnd-components": "/layout-dnd-components/static-1.12316",
      "layout-dnd-utils": "/layout-dnd-utils/static-1.11291",
      "react-codemirror": "/react-codemirror/static-1.10560",
      "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9015",
      "js-cookie": "/js-cookie/static-1.18",
      "products-ui-components": "/products-ui-components/static-1.39794",
      "quotes-ui-lib": "/quotes-ui-lib/static-1.80461",
      "zustand": "/zustand/static-1.72",
      "accounting-integrations-ui-components": "/accounting-integrations-ui-components/static-1.6955",
      "invoices-ui-lib": "/invoices-ui-lib/static-1.54501",
      "commerce-products-api": "/commerce-products-api/static-1.2193",
      "invoices-iframe-lib": "/invoices-iframe-lib/static-1.56559",
      "quotes-modal-lib": "/quotes-modal-lib/static-1.102418",
      "platform-infra-nav-components": "/platform-infra-nav-components/static-1.7619",
      "reporting-ui-components": "/reporting-ui-components/static-2.64481",
      "subscription-experience-data-types": "/subscription-experience-data-types/static-1.14821",
      "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.17986",
      "stripe-connect-js": "/stripe-connect-js/static-1.67",
      "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9481",
      "nested-table": "/nested-table/static-1.163",
      "chatspot-widget-iframe": "/chatspot-widget-iframe/static-1.20961",
      "collaboration-sidebar-common": "/collaboration-sidebar-common/static-1.2383",
      "crm-properties-common-lib": "/crm-properties-common-lib/static-1.5813",
      "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.4191",
      "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.2176",
      "nudge-renderer-utils": "/nudge-renderer-utils/static-1.2495",
      "whisper-core-api": "/whisper-core-api/static-1.6405",
      "property-management-common": "/property-management-common/static-1.5222",
      "d3": "/d3/static-1.7",
      "advanced-menus-core": "/advanced-menus-core/static-1.15025",
      "advanced-menus-lib": "/advanced-menus-lib/static-1.11980",
      "ExportDialog": "/ExportDialog/static-6.10329",
      "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.33855",
      "embedded-academy-lib": "/embedded-academy-lib/static-1.14111",
      "highlight.js": "/highlight.js/static-1.77",
      "reporting-action-components": "/reporting-action-components/static-1.41115",
      "reporting-snowflake": "/reporting-snowflake/static-1.55828",
      "diff-match-patch": "/diff-match-patch/static-1.7",
      "layout-data-lib": "/layout-data-lib/static-1.9616",
      "browser-eslint": "/browser-eslint/static-2.57",
      "commerce-tax-lib": "/commerce-tax-lib/static-1.457",
      "property-description-translator": "/property-description-translator/static-1.3784",
      "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3565",
      "totals-ui-components": "/totals-ui-components/static-1.23395",
      "reporting-plugins": "/reporting-plugins/static-1.10186",
      "reporting-reports": "/reporting-reports/static-1.66888",
      "edison-service-client-types": "/edison-service-client-types/static-1.324",
      "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10445",
      "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.16860",
      "marketplace-ui-common": "/marketplace-ui-common/static-1.19453",
      "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.7931",
      "react-window": "/react-window/static-1.13",
      "ts-utils-lib": "/ts-utils-lib/static-1.110",
      "seamless-immutable": "/seamless-immutable/static-7.6",
      "simple-menus-core": "/simple-menus-core/static-1.15024",
      "simple-menus-lib": "/simple-menus-lib/static-1.16541",
      "academy-common-lib": "/academy-common-lib/static-1.13571",
      "dashboard-lib": "/dashboard-lib/static-1.81254",
      "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8634",
      "commerce-totals-service-types": "/commerce-totals-service-types/static-1.3770",
      "campaign-roi-lib": "/campaign-roi-lib/static-1.8827",
      "apps-service-types": "/apps-service-types/static-1.3815",
      "oauth-service-types": "/oauth-service-types/static-1.4187",
      "academy-service-client": "/academy-service-client/static-1.3618",
      "croppie": "/croppie/static-2.10",
      "redux-actions": "/redux-actions/static-3.7"
    },
    "bundlingPackage": "conversations-visitor-ui",
    "bundlingPackageVersion": "static-1.28901",
    "project": "conversations-visitor-ui",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};